// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAddMilestoneButton_root__I9-Yg","text__rpt3B":"PlasmicAddMilestoneButton_text__rpt3B__+tdTU","text__hFdlW":"PlasmicAddMilestoneButton_text__hFdlW__WXRbu"};